import { $menu } from '@/views/menu/menu';
import { userSettings } from "@/globals/userSettings";

export default function selectButtons($menu: HTMLElement) {
  const states = userSettings.states;
  if (states) {
    const buttons = Array.from(
      $menu.querySelectorAll(".cya11y-btn")
    ) as HTMLElement[];

    Object.entries(states).forEach(([key, value]) => {
      if (value && key !== "fontSize") {
        const selector = key === "contrast" ? states[key] : key;
        const btn = buttons.find((b) => b.dataset.key === selector);
        if (btn) btn.classList.add("cya11y-selected");
      }else{
        const btn = buttons.find((b) => b.dataset.key === key);
        if (btn) btn.classList.remove("cya11y-selected");
        if(key === "contrast"){
          const filterBtn = $menu.querySelectorAll(".cya11y-filter");
          filterBtn.forEach((btn) => {
            btn.classList.remove("cya11y-selected");
          });
        }
      }
    });
  }
}